// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"544":"d86bf1a7","896":"7cbd9961"}[chunkId] + ".css";
};